module.exports = __webpack_public_path__ + "img/logo.fa695f21.svg";